import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from './Logo';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0f1c]">
      {/* Header */}
      <nav className="bg-[#0a0f1c]/95 backdrop-blur-md border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Logo className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Quay Lại Trang Chủ
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Điều Khoản Dịch Vụ
          </h1>
          <p className="text-gray-500 mb-8">Cập nhật lần cuối: Tháng 2, 2026</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Giới Thiệu</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chào mừng bạn đến với Nhamy.us ("Trang web", "Chúng tôi", "Công ty"). Bằng cách truy cập và sử dụng trang web này, bạn đồng ý tuân thủ các điều khoản và điều kiện sau đây.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Nhamy.us là một nền tảng kết nối người tiêu dùng với các chuyên gia cho vay thế chấp được cấp phép để cung cấp thông tin về các sản phẩm vay mua nhà và tái cấp vốn. Chúng tôi hợp tác với nhiều tổ chức cho vay uy tín trên toàn quốc để mang đến cho bạn các lựa chọn tốt nhất.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Dịch Vụ Của Chúng Tôi</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nhamy.us cung cấp các dịch vụ sau:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>So sánh lãi suất vay thế chấp từ nhiều tổ chức cho vay</li>
                <li>Kết nối với các chuyên gia tư vấn vay được cấp phép</li>
                <li>Công cụ tính toán và ước tính khoản vay</li>
                <li>Thông tin giáo dục về quy trình mua nhà và vay thế chấp</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Đồng Ý Liên Lạc (TCPA)</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Bằng cách gửi thông tin liên hệ của bạn thông qua trang web này, bạn đồng ý rõ ràng rằng:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Nhamy.us và các đối tác cho vay của chúng tôi có thể liên hệ với bạn về các sản phẩm và dịch vụ vay thế chấp</li>
                <li>Chúng tôi có thể liên lạc qua điện thoại, tin nhắn SMS/MMS, và email</li>
                <li>Các cuộc gọi có thể được thực hiện bằng hệ thống quay số tự động hoặc sử dụng tin nhắn ghi âm trước</li>
                <li>Sự đồng ý này không phải là điều kiện để được nhận báo giá hoặc mua bất kỳ sản phẩm nào</li>
                <li>Bạn có thể thu hồi sự đồng ý này bất cứ lúc nào bằng cách liên hệ với chúng tôi</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Cước tin nhắn và dữ liệu có thể áp dụng tùy theo nhà mạng của bạn.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Đối Tác Cho Vay</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nhamy.us hợp tác với một mạng lưới rộng lớn các tổ chức cho vay được cấp phép ("Đối Tác Cho Vay"), bao gồm các ngân hàng, công ty thế chấp, và tổ chức tài chính uy tín. Khi bạn gửi yêu cầu thông qua trang web:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Thông tin của bạn có thể được chia sẻ với một hoặc nhiều Đối Tác Cho Vay phù hợp với nhu cầu của bạn</li>
                <li>Đối Tác Cho Vay có thể liên hệ trực tiếp với bạn để thảo luận về các lựa chọn vay</li>
                <li>Mỗi Đối Tác Cho Vay có các điều khoản và điều kiện riêng của họ</li>
                <li>Chúng tôi không đảm bảo rằng bạn sẽ đủ điều kiện cho bất kỳ sản phẩm vay cụ thể nào</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Tuyên Bố Từ Chối Trách Nhiệm</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Thông tin trên trang web này chỉ mang tính chất tham khảo và không cấu thành lời khuyên tài chính, pháp lý hoặc thuế. Chúng tôi khuyên bạn nên:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Tham khảo ý kiến của chuyên gia tài chính trước khi đưa ra quyết định vay</li>
                <li>Xem xét kỹ tất cả các điều khoản và điều kiện của bất kỳ sản phẩm vay nào</li>
                <li>So sánh nhiều lựa chọn trước khi quyết định</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Lãi suất, phí và các điều khoản có thể thay đổi mà không cần thông báo trước.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Quyền Sở Hữu Trí Tuệ</h2>
              <p className="text-gray-700 leading-relaxed">
                Tất cả nội dung trên trang web này, bao gồm văn bản, hình ảnh, logo, và phần mềm, đều thuộc sở hữu của Nhamy.us hoặc các bên cấp phép của chúng tôi. Bạn không được sao chép, phân phối, hoặc sử dụng bất kỳ nội dung nào mà không có sự đồng ý bằng văn bản từ chúng tôi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Giới Hạn Trách Nhiệm</h2>
              <p className="text-gray-700 leading-relaxed">
                Trong phạm vi tối đa được pháp luật cho phép, Nhamy.us không chịu trách nhiệm về bất kỳ thiệt hại trực tiếp, gián tiếp, ngẫu nhiên, đặc biệt hoặc hậu quả nào phát sinh từ việc sử dụng trang web này hoặc dịch vụ của chúng tôi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Thay Đổi Điều Khoản</h2>
              <p className="text-gray-700 leading-relaxed">
                Chúng tôi có quyền sửa đổi các điều khoản này bất cứ lúc nào. Các thay đổi sẽ có hiệu lực ngay khi được đăng trên trang web. Việc bạn tiếp tục sử dụng trang web sau khi các thay đổi được đăng tải đồng nghĩa với việc bạn chấp nhận các điều khoản đã sửa đổi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Liên Hệ</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nếu bạn có bất kỳ câu hỏi nào về Điều Khoản Dịch Vụ này, vui lòng liên hệ với chúng tôi:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700"><strong>Nhamy.us</strong></p>
                <p className="text-gray-700">Email: support@nhamy.us</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Luật Áp Dụng</h2>
              <p className="text-gray-700 leading-relaxed">
                Các điều khoản này được điều chỉnh theo luật pháp của Tiểu bang California, Hoa Kỳ, mà không tính đến các nguyên tắc xung đột pháp luật.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0d1424] border-t border-gray-800 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm">
            © 2026 Nhamy.us. Bảo lưu mọi quyền.
          </p>
          <div className="flex justify-center gap-6 mt-4">
            <Link to="/terms" className="text-gray-400 hover:text-[#10b981] text-sm">Điều Khoản Dịch Vụ</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-[#10b981] text-sm">Chính Sách Bảo Mật</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
